// extracted by mini-css-extract-plugin
export var attribution = "_cx-4";
export var authorName = "_cx-5";
export var quote = "_cx-3";
export var testimonial = "_cx-2";
export var trustedBy = "_cx-0";
export var trustedByLabel = "_cx-1";